import { PAGES_TYPES } from 'constants/pagesTypes';

import { oneCReviewsPropsData } from './oneCData';
import { retailReviewsPropsData } from './retailData';
import { defaultReviewsPropsData } from './defaultData';
import { telecomReviewsPropsData } from './telecomData';
import { oilAndGasReviewsPropsData } from './oilAndGasData';

export const reviewsPdfLinkText = 'Смотреть рекомендательное письмо';

export const reviewsPropsSelector = {
  [PAGES_TYPES.oilAndGas]: oilAndGasReviewsPropsData,
  [PAGES_TYPES.telecom]: telecomReviewsPropsData,
  [PAGES_TYPES.retail]: retailReviewsPropsData,
  [PAGES_TYPES.oneC]: oneCReviewsPropsData,

  default: defaultReviewsPropsData,
};
